import axios from 'axios'
import { extractFormData, getFileFormUrl } from 'src/core/helpers'
import { BigSale, Sale } from 'src/core/models'
import { PendingSale } from 'src/core/models/sales-slice.type'

const KEYS = ['creditOffsettingReceipt', 'cancellationCertificate', 'taxReliefDocument', 'carbonForwardPurchaseAgreementDocument']
const loadDocuments = async (data: BigSale) => {
  for (const key of KEYS) {
    if (data[key]) {
      data[key + '_file'] = await getFileFormUrl(`${data.url}${data[key]}`)
      data[key + '_file'].url = `${data.url}${data[key]}`
    }
  }
}

export async function getSaleListAPI(currency_code: string): Promise<Sale[]> {
  const url = `/api/v1/projects_purchases/projects_sales/?currency_code=${currency_code}`
  const { data } = await axios.get<Sale[]>(url)
  return data
}

export async function getSaleDetailsAPI(saleId: number): Promise<BigSale> {
  const url = `/api/v1/projects_purchases/project_sale/?id=${saleId}`
  const { data } = await axios.get<BigSale>(url)
  const sale = data[0]
  await loadDocuments(sale)
  return sale
}

export async function sendDocumentAPI(saleId: number, file: any, key: string): Promise<any> {
  const url = `/api/v1/orders/upload_certificate/`
  const payload = {
    'id': saleId,
    'isCertificate': key === 'cancellationCertificate' ? 'true' : 'false',
    'isReceipt': key === 'creditOffsettingReceipt' ? 'true' : 'false',
    'isTaxReliefDocument': key === 'taxReliefDocument' ? 'true' : 'false',
    'taxReliefDocument': key === 'taxReliefDocument' ? file : null,
    'receipt': key === 'creditOffsettingReceipt' ? file : null,
    'certificate': key === 'cancellationCertificate' ? file : null,
    'isCarbonForwardDocument': key === 'carbonForwardPurchaseAgreementDocument' ? 'true' : 'false',
    'carbonForwardDocument': key === 'carbonForwardPurchaseAgreementDocument' ? file : null
  }
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  const body = extractFormData(payload)
  const { data } = await axios.post(url, body, config)
  return data
}

export async function deleteDocumentAPI(saleId: number, key: string): Promise<any> {
  const entryPoint = {
    creditOffsettingReceipt: '/delete_receipt/',
    taxReliefDocument: '/delete_tax_relief_document/',
    cancellationCertificate: '/delete_certificate/',
    carbonForwardPurchaseAgreementDocument: '/delete_carbon_forward_document/'
  }[key]
  const url = `/api/v1/orders/${saleId}${entryPoint}`
  const { data } = await axios.delete(url)
  return data
}

export async function getPendingSales(): Promise<PendingSale[]> {
  const url = `/api/v1/projects_purchases/get_pending_sales/`
  const { data } = await axios.get<PendingSale[]>(url)
  return data
}
